export const getEmptySfdt = () => {
    return `{"sections": [{"blocks": [{"inlines": [{"characterFormat": {"bold": true,"italic": true},"text": ""}]}],"headersFooters": {}}]}`
}

export const getMergedFields = ({t,getCopyTextComponent})=>{
    return  [
        {
            text: t('general.general'),
            children: [
                {
                    text: `${t('taskAutomation.mergeField.dateAtSending')} [huidige_datum]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'huidige_datum', toastValue: t('taskAutomation.mergeField.dateAtSending') })
                },
                {
                    text: `${t('taskAutomation.mergeField.dateAtSending')} ${t('taskAutomation.mergeField.long')} [huidige_datum_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'huidige_datum_lang', toastValue: t('taskAutomation.mergeField.dateAtSending') + ' ' + t('taskAutomation.mergeField.long') })
                },
            ]
        },
        { 
            text: t('general.project'), 
            children: [
                { 
                    text: `${t('general.projectNumber')} [werknummer]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werknummer', toastValue: t('general.projectNumber')}) 
                },
                { 
                    text: `${t('general.projectName')} [werknaam]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werknaam', toastValue: t('general.projectName') }) 
                },
                { 
                    text: `${t('general.address.city')} [werk_plaats]`, 
                    icon: getCopyTextComponent({ clipBoardValue:"werk_plaats", toastValue: t('general.address.city') }) 
                },
                { 
                    text: `${t('general.warranty')} [werk_planregistratienummer]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_planregistratienummer', toastValue: t('general.warranty')}) 
                },
                { 
                    text: `${t('general.salesStartDate')} [werk_datum_start_verkoop]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_datum_start_verkoop', toastValue: t('general.salesStartDate') }) 
                },
                { 
                    text: `${t('general.salesStartDate')} ${t('taskAutomation.mergeField.long')} [werk_datum_start_verkoop_lang]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_datum_start_verkoop_lang', toastValue: t('general.salesStartDate') + ' ' + t('taskAutomation.mergeField.long') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.projectStartDate')} [werk_datum_start_bouw]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_datum_start_bouw', toastValue: t('taskAutomation.mergeField.projectStartDate') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.projectStartDate')} ${t('taskAutomation.mergeField.long')} [werk_datum_start_bouw_lang]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_datum_start_bouw_lang', toastValue: t('taskAutomation.mergeField.projectStartDate')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.projectEndDate')} [werk_datum_eind_bouw]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_datum_eind_bouw', toastValue: t('taskAutomation.mergeField.projectEndDate') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.projectEndDate')} ${t('taskAutomation.mergeField.long')} [werk_datum_eind_bouw_lang]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_datum_eind_bouw_lang', toastValue:  t('taskAutomation.mergeField.projectEndDate')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                { 
                    text: `${t('general.website')} [werk_website]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_website', toastValue: t('general.website'),   }) 
                },
                { 
                    text: `${t('general.warrantyScheme')} [werk_garantieregeling]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_garantieregeling', toastValue:  t('general.warrantyScheme')}) 
                },
                { 
                    text: `${t('general.endOfMaintenancePeriod')} [werk_onderhoudstermijn]`, 
                    icon: getCopyTextComponent({ clipBoardValue: 'werk_onderhoudstermijn', toastValue: t('general.endOfMaintenancePeriod') }) 
                },
            ] 
        },
        { 
            text: t('general.object'), 
            children: [
                { 
                    text: `${t('general.buildingNumber.internal')} [bouwnummer_intern]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bouwnummer_intern', toastValue: t('general.buildingNumber.internal') }) 
                },
                { 
                    text: `${t('general.buildingNumber.external')} [bouwnummer_extern]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bouwnummer_extern', toastValue:  t('general.buildingNumber.external')}) 
                },
                {
                    text: `${t('general.buyerRenter')} [volledige_naam]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'volledige_naam', toastValue: t('general.buyerRenter') })
                },
                {
                    text: `${t('taskAutomation.mergeField.currentAddressBuyersRenters')} [geadresseerde_adresblok]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'geadresseerde_adresblok', toastValue: t('taskAutomation.mergeField.currentAddressBuyersRenters') })
                },
                { 
                    text: `${t('general.country')} [object_land]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_land', toastValue: t('general.country')}) 
                },
                { 
                    text: `${t('general.address.city')} [object_plaats]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_plaats', toastValue: t('general.address.city')}) 
                },
                { 
                    text: `${t('general.address.postcode')} [object_postcode]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_postcode', toastValue: t('general.address.postcode') }) 
                },
                { 
                    text: `${t('general.address.houseNumber')} [object_huisnummer]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_huisnummer', toastValue: t('general.address.houseNumber') }) 
                },
                { 
                    text: `${t('general.address.street')} [object_straat]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_straat', toastValue: t('general.address.street') }) 
                },
                { 
                    text: `${t('general.eanCodeElectricity')} [ean_elektriciteit]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'ean_elektriciteit', toastValue: t('general.eanCodeElectricity')}) 
                },
                { 
                    text: `${t('general.eanCodeGas')} [ean_gas]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'ean_gas', toastValue: t('general.eanCodeGas') }) 
                },
                { 
                    text: `${t('general.startDate')} [object_datum_start_bouw]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_datum_start_bouw', toastValue: t('general.startDate') }) 
                },
                { 
                    text: `${t('general.startDate')} ${t('taskAutomation.mergeField.long')} [object_datum_start_bouw_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'object_datum_start_bouw_lang', toastValue: t('general.startDate')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.startDateObjectOrProject')} [datum_start_bouw]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_start_bouw', toastValue:t('taskAutomation.mergeField.startDateObjectOrProject') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.startDateObjectOrProject')} ${t('taskAutomation.mergeField.long')} [datum_start_bouw_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_start_bouw_lang', toastValue:t('taskAutomation.mergeField.startDateObjectOrProject')+ ' ' + t('taskAutomation.mergeField.long')}) 
                },
                { 
                    text: `${t('general.preDelivery')} [datum_voorschouw]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_voorschouw', toastValue:t('general.preDelivery') }) 
                },
                { 
                    text: `${t('general.preDelivery')} ${t('taskAutomation.mergeField.long')} [datum_voorschouw_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_voorschouw_lang', toastValue:t('general.preDelivery')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                {
                    text: `${t('taskAutomation.mergeField.preDeliveryTimeFrom')} [tijd_voorschouw_va]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'tijd_voorschouw_va', toastValue: t('taskAutomation.mergeField.preDeliveryTimeFrom') })
                },
                {
                    text: `${t('taskAutomation.mergeField.preDeliveryTimeTo')} [tijd_voorschouw_tm]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'tijd_voorschouw_tm', toastValue: t('taskAutomation.mergeField.preDeliveryTimeTo') })
                },
                { 
                    text: `${t('general.delivery')} [datum_oplevering]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_oplevering', toastValue: t('general.delivery') }) 
                },
                { 
                    text: `${t('general.delivery')} ${t('taskAutomation.mergeField.long')} [datum_oplevering_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_oplevering_lang', toastValue: t('general.delivery')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                {
                    text: `${t('taskAutomation.mergeField.deliveryTimeFrom')} [tijd_oplevering_va]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'tijd_oplevering_va', toastValue: t('taskAutomation.mergeField.deliveryTimeFrom') })
                },
                {
                    text: `${t('taskAutomation.mergeField.deliveryTimeTo')} [tijd_oplevering_tm]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'tijd_oplevering_tm', toastValue: t('taskAutomation.mergeField.deliveryTimeTo') })
                },
                { 
                    text: `${t('general.secondSignature')} [datum_tweede_handtekening]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_tweede_handtekening', toastValue: t('general.secondSignature') })
                },
                { 
                    text: `${t('general.secondSignature')} ${t('taskAutomation.mergeField.long')} [datum_tweede_handtekening_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'datum_tweede_handtekening_lang', toastValue: t('general.secondSignature')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.lastQuotationClosingDate')} [laatste_offerte]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'laatste_offerte', toastValue: t('taskAutomation.mergeField.lastQuotationClosingDate') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.lastQuotationClosingDate')} ${t('taskAutomation.mergeField.long')} [laatste_offerte_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'laatste_offerte_lang', toastValue: t('taskAutomation.mergeField.lastQuotationClosingDate')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },
                {
                    text: `${t('buyersGuide.warrantyCertificateNumber')} [certificaat_nummer]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'certificaat_nummer', toastValue: t('buyersGuide.warrantyCertificateNumber') })
                },
                { 
                    text: `${t('general.warrantyScheme')} [garantieregeling]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'garantieregeling', toastValue: t('general.warrantyScheme') }) 
                },
                { 
                    text: `${t('general.endOfMaintenancePeriod')} [einde_onderhoudstermijn]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'einde_onderhoudstermijn', toastValue: t('general.endOfMaintenancePeriod') }) 
                },
                { 
                    text: `${t('general.endOfMaintenancePeriod')} ${t('taskAutomation.mergeField.long')} [einde_onderhoudstermijn_lang]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'einde_onderhoudstermijn_lang', toastValue: t('general.endOfMaintenancePeriod')+ ' ' + t('taskAutomation.mergeField.long') }) 
                },

            ] 
        },
        { 
            text: t('general.company'), 
            children: [
                { 
                    text: `${t('general.name')} [bedrijf_naam]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_naam', toastValue: t('general.name') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.visitingAddressCountry')} [bedrijf_bezoekadres_land]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_bezoekadres_land', toastValue: t('taskAutomation.mergeField.company.visitingAddressCountry')}) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.visitingAddressNumber')} [bedrijf_bezoekadres_nummer]`,
                    icon: getCopyTextComponent({ clipBoardValue:  'bedrijf_bezoekadres_nummer', toastValue: t('taskAutomation.mergeField.company.visitingAddressNumber')}) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.visitingAddressCity')} [bedrijf_bezoekadres_plaats]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_bezoekadres_plaats', toastValue: t('taskAutomation.mergeField.company.visitingAddressCity') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.visitingAddressPostCode')} [bedrijf_bezoekadres_postcode]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_bezoekadres_postcode', toastValue: t('taskAutomation.mergeField.company.visitingAddressPostCode') }) 
                },

                { 
                    text: `${t('taskAutomation.mergeField.company.visitingAddressStreet')} [bedrijf_bezoekadres_straat]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_bezoekadres_straat' , toastValue: t('taskAutomation.mergeField.company.visitingAddressStreet') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.mailingAddressCountry')} [bedrijf_postadres_land]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_postadres_land', toastValue: t('taskAutomation.mergeField.company.mailingAddressCountry')}) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.mailingAddressNumber')} [bedrijf_postadres_nummer]`,
                    icon: getCopyTextComponent({ clipBoardValue:  'bedrijf_postadres_nummer', toastValue: t('taskAutomation.mergeField.company.mailingAddressNumber')}) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.mailingAddressCity')} [bedrijf_postadres_plaats]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_postadres_plaats', toastValue: t('taskAutomation.mergeField.company.mailingAddressCity') }) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.mailingAddressPostCode')} [bedrijf_postadres_postcode]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_postadres_postcode', toastValue: t('taskAutomation.mergeField.company.mailingAddressPostCode')}) 
                },
                { 
                    text: `${t('taskAutomation.mergeField.company.mailingAddressStreet')} [bedrijf_postadres_straat]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_postadres_straat', toastValue: t('taskAutomation.mergeField.company.mailingAddressStreet') }) 
                },
                { 
                    text: `${t('general.telephone')} [bedrijf_telefoon]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_telefoon', toastValue: t('general.telephone') }) 
                },
                { 
                    text: `${t('general.email')} [bedrijf_email]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_email', toastValue:  t('general.email') }) 
                },
                {
                    text: `${t('general.website')} [bedrijf_website]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_website', toastValue: t('general.website') }) 
                },
                { 
                    text: `${t('general.bank')} [bedrijf_banknaam]`,
                    icon: getCopyTextComponent({ clipBoardValue:'bedrijf_banknaam', toastValue: t('general.bank')}) 
                },
                { 
                    text: `${t('general.bic')} [bedrijf_bic]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_bic', toastValue: t('general.bic') }) 
                },
                {
                    text: `${t('general.iban')} [bedrijf_iban]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_iban', toastValue: t('general.iban') }) 
                },
                { 
                    text: `${t('general.cocNumber')} [bedrijf_kvk_nummer]`,
                    icon: getCopyTextComponent({ clipBoardValue: 'bedrijf_kvk_nummer', toastValue: t('general.cocNumber') }) 
                },
                { 
                    text: `${t('general.vatNumber')} [bedrijf_btw_nummer]`,
                    icon: getCopyTextComponent({ clipBoardValue:'bedrijf_btw_nummer', toastValue: t('general.vatNumber') }) 
                }, 

            ] 
        },
              
    ];
}